import { render, staticRenderFns } from "./WaterSampleDetail.vue?vue&type=template&id=6408e389"
import script from "./WaterSampleDetail.vue?vue&type=script&lang=js"
export * from "./WaterSampleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports